import React from "react"
import cls from "classnames"

type IProps = {
  name: string
  className?: string
}

const Icon = ({ name, className }: IProps) => {
  return <i className={cls(`iconfont icon-${name}`, className)} />
}

export default Icon
